import { render, staticRenderFns } from "./MenuPopup.vue?vue&type=template&id=c6299db8&scoped=true"
import script from "./MenuPopup.vue?vue&type=script&lang=ts"
export * from "./MenuPopup.vue?vue&type=script&lang=ts"
import style0 from "./MenuPopup.vue?vue&type=style&index=0&id=c6299db8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6299db8",
  null
  
)

export default component.exports